// extracted by mini-css-extract-plugin
export default {"content":"Effectiveness_content__IVgeX","container":"Effectiveness_container__RhETQ","list":"Effectiveness_list__RQAUH"};